import classNames from 'classnames';

import BannerCenteredContent from 'components/Banner/BannerCenteredContent';

import AspectRatio from 'components/AspectRatio';
import { AspectRatioDimensions } from 'components/AspectRatio/enums';

import type { AnimatedBannerWithBulletsProps } from './types';

import useContentStyles from './Content/styles';
import useStyles from './styles';

function AnimatedBannerWithBulletsFallback({ reversed }: AnimatedBannerWithBulletsProps) {
  const contentStyles = useContentStyles();
  const styles = useStyles();

  const wrapperClassNames = classNames(styles.root, { reversed });

  return (
    <BannerCenteredContent autoDimensions>
      <div className={wrapperClassNames} data-testid="AnimatedBannerWithBullets-fallback">
        <div className={styles.productWrapper}>
          <div className={classNames(contentStyles.title, styles.titleFallback)}>
            <i className="skeleton" />
          </div>
          <div className={styles.bulletsFallback}>
            <i className="skeleton" />
            <i className="skeleton" />
            <i className="skeleton" />
            <i className="skeleton" />
          </div>
          <div className={styles.actionFallback}>
            <i className="skeleton" />
          </div>
          <div className={classNames(contentStyles.secondDescription, styles.descFallback)}>
            <i className="skeleton" />
          </div>
        </div>
        <div className={styles.mediaWrapper}>
          <AspectRatio
            dimension={{
              xl: AspectRatioDimensions.Full,
            }}
          >
            <i className="skeleton" />
          </AspectRatio>
        </div>
      </div>
    </BannerCenteredContent>
  );
}

export default AnimatedBannerWithBulletsFallback;
